import { useMutation } from 'react-query';

import { parseAirbnbInvoice } from 'modules/accommodations/features/reservations/api';

export const useMutationParseAirbnbInvoice = () => {
  return useMutation(parseAirbnbInvoice);
};
